import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { PrepaidSimState, Item } from '@/store/prepaidSim/state';
import getters from './getters';
import mutations from './mutations';

import { PrepaidSimConfig } from '@/data/prepaidSimConfig';
import { Plan } from '@/data/prepaidSim/plan';
import json from '../../../config/prepaid_sim.json';
const config = new PrepaidSimConfig(json);

const initialize = (): Item[] => {
  return config.plans.reduce((z: Item[], plan: Plan) => {
    z.push({ id: plan.id, count: 0 });
    return z;
  }, []);
};

const state: PrepaidSimState = {
  prepaidSim: initialize(),
};

export const prepaidSim: Module<PrepaidSimState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
};
